<template>
    <div class="avaContainer">
        <img v-bind:src="animationPath" v-if="currentAnimation" style="width:300px; height:540px;" />
       
    </div>
</template>
<script>
    import Vue from 'vue';
    import { mapState, mapActions } from 'vuex';
    import animations from '../store/animations';
  
    export default {
        namespaced: true,
        name: 'Ava',
        data() {
            return {
                baseUrl: process.env.BASE_URL
            }
        },
        computed: {
            ...mapState({
                currentAnimation: state => state.ava.currentAnimation,
                animationPath() {
                    return this.baseUrl + 'ava/' + this.currentAnimation + '.gif';
                }
            })
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    h3 {
        margin: 40px 0 0;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    .avaContainer {
        float: left;
        width: 300px;
        height: 540px;
    }
</style>
